/** Copyright (c) 2022 T.Rowe Price. All rights reserved. */

import './ExcessAccountsPage.scss';
import React from 'react';

import Content from 'services/Content';

import { contentConverter } from 'services/Content';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';

const convertedContent = contentConverter.makeHtml(
  Content.excessAccountsDetailMessage
);

const ExcessAccountsPage = () => (
  <div className="excess-accounts-container">
    <WarningIcon className="excess-accounts-icon" />
    <div className="excess-accounts-title">
      We could not display your account balances for
      <br />
      viewing due to a data capacity issue.
    </div>
    <div className="excess-accounts-message">
      <span dangerouslySetInnerHTML={{ __html: convertedContent }} />
    </div>
  </div>
);

export default ExcessAccountsPage;
